import BaseAPI, { MAX_LIST_LIMIT } from "./BaseAPI";
import { vanCheckRoute } from "../routes";

export default class VanCheckAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, vanCheckRoute, "van-check");
    }

    async List(params = {}) {
        return super.List({ limit: MAX_LIST_LIMIT, ...params });
    }

    async Update(id, data) {
        return this._request("put", this._url(`/${id}`), data);
    }

    getEmptyVanCheck() {
        return {};
    }
}
